import React from "react";
import { Link } from "react-router-dom";
import RotatingPromo from "./RotatingPromo";

const Header = () => {
  return (
    <>
      <div className="sm:hidden w-full py-1 px-2 text-xs font-mono whitespace-nowrap overflow-hidden text-center text-[--text-secondary] bg-black text-white border-b border-[--border-color]">
        AFFILIATE: We earn from qualifying purchases.
      </div>

      <header className="border-b border-gray-200 py-3">
        <div className="max-w-[1400px] mx-auto px-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 sm:gap-6">
              <Link
                to="/"
                className="flex items-center gap-2 hover:text-[--accent] transition-colors"
              >
                <span className="text-xl" role="img" aria-label="Orange">
                  🍊
                </span>
                <h1 className="text-xl font-bold">Lo-Fee.com</h1>
              </Link>
              <div className="block">
                <RotatingPromo />
              </div>
            </div>

            <div className="hidden sm:block px-4 py-1 text-xs font-mono text-[--text-secondary] bg-[--bg-primary] border border-[--border-color]">
              AFFILIATE DISCLAIMER - We earn from qualifying purchases.
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
